export default __webpack_public_path__ + "static/media/arrow-small.b7577721.svg";